import { logger } from "@/utils/logger";
import {Order, Task, TaskExecuteAction, TaskModule, TaskState} from "@/types";
import {executeTask} from "@/store/services/task/workflow";
import {deepClone} from "@/utils";

export async function executeStartOrder(taskState: TaskState, order: Order, task: Task) {
    const startOrder = deepClone(taskState.startOrderModule.bind)
    const {
        decisionDate,
        comment,
        decision
    } = startOrder
    // TODO verify if need to save the decision on the database
    const taskExecuteAction: TaskExecuteAction = {
        taskId: task.taskId || '',
        variables: {
            orderStatus: { value: decision === 'start' ? 'ORDER_STARTED' : 'ORDER_REJECTED', type: "String" }
        }
    }
    try {
        return executeTask(taskExecuteAction)
    } catch (e) {
        logger.error(e)
        return Promise.reject(e)
    }
}
